import { render, staticRenderFns } from "./ConfirmationModalHolidays.vue?vue&type=template&id=084715af"
import script from "./ConfirmationModalHolidays.vue?vue&type=script&lang=js"
export * from "./ConfirmationModalHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports